"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import type { STATEMENT_TYPE } from "@/helpers/Types";
import { STATEMENT_META } from "@/helpers/Types";
import SocialStatementIcon from "@/components/user/utils/icons/SocialStatementIcon";
export default function UserPageIdentityAddStatementsTypeButton(t0) {
  const $ = _c(23);
  const {
    statementType,
    isActive,
    isFirst,
    isLast,
    onClick
  } = t0;
  let t1;
  if ($[0] !== isActive) {
    t1 = () => isActive ? "tw-bg-iron-800" : "tw-bg-transparent";
    $[0] = isActive;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getActivityClass = t1;
  let t2;
  if ($[2] !== isFirst || $[3] !== isLast) {
    t2 = () => {
      if (isFirst) {
        return "tw-rounded-l-md";
      } else {
        if (isLast) {
          return "tw-rounded-r-md";
        }
      }
      return "";
    };
    $[2] = isFirst;
    $[3] = isLast;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const getPositionClass = t2;
  let t3;
  if ($[5] !== getActivityClass || $[6] !== getPositionClass) {
    t3 = () => `${getActivityClass()} ${getPositionClass()}`;
    $[5] = getActivityClass;
    $[6] = getPositionClass;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const getDynamicClasses = t3;
  const [dynamicClasses, setDynamicClasses] = useState(getDynamicClasses());
  let t4;
  if ($[8] !== getDynamicClasses) {
    t4 = () => {
      setDynamicClasses(getDynamicClasses());
    };
    $[8] = getDynamicClasses;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== isActive || $[11] !== isFirst || $[12] !== isLast) {
    t5 = [isActive, isFirst, isLast];
    $[10] = isActive;
    $[11] = isFirst;
    $[12] = isLast;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  useEffect(t4, t5);
  const t6 = `${dynamicClasses} tw-relative -tw-ml-px tw-flex tw-items-center tw-justify-center tw-flex-1 tw-py-3 tw-text-sm tw-font-semibold tw-text-iron-100 tw-border-none tw-ring-1 tw-ring-inset tw-ring-iron-800 hover:tw-bg-iron-800 tw-transition tw-duration-300 tw-ease-out tw-focus:tw-z-10`;
  let t7;
  if ($[14] !== statementType) {
    t7 = <div className="tw-flex-shrink-0 tw-w-5 tw-h-5"><SocialStatementIcon statementType={statementType} /></div>;
    $[14] = statementType;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = STATEMENT_META[statementType];
  let t9;
  if ($[16] !== t8.title) {
    t9 = <span className="tw-sr-only">{t8.title}</span>;
    $[16] = t8.title;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== onClick || $[19] !== t6 || $[20] !== t7 || $[21] !== t9) {
    t10 = <button onClick={onClick} type="button" className={t6}>{t7}{t9}</button>;
    $[18] = onClick;
    $[19] = t6;
    $[20] = t7;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}